import React, { useEffect, useRef, useState } from "react";
import {
  Image as RNImage,
  StyleSheet,
  Text as RNText,
  View,
} from "react-native";
import { Box, Flex, Image, Text, useColorMode, useToast } from "native-base";
import TemplateEtapas from "../../../template/Etapas/Index";
import { CORES, sombraCard } from "../../../template/Etapas/styles";
import {
  corComAlpha,
  corTextoSobre,
  gradienteCard,
} from "../../../theme/cores";
import { useNavigation, useRoute } from "@react-navigation/native";
import Api from "../../../../Api/Api";
import createStyle from "./styles";
import Template from "../../../template/Index.tsx";
import { useTheme } from "../../../../ThemeProvider.tsx";
import ModalConfirmacao from "../../../../components/ModalConfirmacao";
import { Card } from "primereact/card";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import { RFPercentage } from "react-native-responsive-fontsize";
import { useToastMessage } from "../../../hooks/useToastMessage";

export default function Confirmacao({}) {
  const toast = useToast();
  const navigation = useNavigation();
  const route = useRoute();

  const [data_selecionada, setDataSelecionada] = useState<Date>(new Date());
  const [servicos_selecionado, setServicos_selecionado] = useState<any>([]);
  const [pacotesSelecionado, setPacotesSelecionado] = useState<any>([]);
  const [total, setTotal] = useState<Number>(0);
  const [nome_cliente, setNome_cliente] = useState<String>("");
  const [telefone_cliente, setTelefone_cliente] = useState<String>("");
  const [
    mensagemConfirmaUtilizacaoPacote,
    setMensagemConfirmaUtilizacaoPacote,
  ] = useState<string>("");
  const [pacotes, setPacotes] = useState<any[]>([]);
  const [pacoteSelecionadoValidacao, setPacoteSelecionadoValidacao] = useState<
    any[]
  >([]);
  const [textoModalInformacao, setTextoModalInformacao] = useState<string>("");
  const [clienteFinal, setClienteFinal] = useState<boolean>(false);

  const { getCodEmpresa, isMobile, configEmpresa, primaryColor } = useTheme();
  const { colorMode } = useColorMode();

  const [getConfigEmpresa, setConfigEmpresa] = useState<any>(
    JSON.parse(configEmpresa),
  );
  const refModal = useRef<any>(null);
  const refModalInformacao = useRef<any>(null);
  const confirmationRef = useRef<any>(null);

  const style = createStyle(getConfigEmpresa.coresPWA);
  const { error } = useToastMessage();

  const meses = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];

  const dias_semana = [
    "Domingo",
    "Segunda-feira",
    "Terça-feira",
    "Quarta-feira",
    "Quinta-feira",
    "Sexta-feira",
    "Sabado",
  ];

  useEffect(() => {
    setDataSelecionada(route.params.data_selecionada);
    setServicos_selecionado(
      route.params.servicos_selecionados
        ? route.params.servicos_selecionados
        : [],
    );
    setPacotesSelecionado(
      route.params.pacoteSelecionado ? route.params.pacoteSelecionado : [],
    );
    setNome_cliente(route.params.cliente.nome);
    setTelefone_cliente(route.params.cliente.telefone);
    setClienteFinal(route.params.cliente.clienteFinal);

    let total = 0;

    if (route.params.servicos_selecionados) {
      for (const servico of route.params.servicos_selecionados) {
        total += parseFloat(servico.valor);
      }
    }

    setTotal(total);
    getPacotesCliente();
  }, []);

  async function validaPacotesDentroPrazo(pacoteVerificar: any[]) {
    const pacotesValidos = pacoteVerificar.filter((item: any) => {
      const data = new Date(item.dataValidade);
      if (data_selecionada <= data) {
        return item;
      }
    });

    return pacotesValidos;
  }

  async function validaItensPacotes(pacotesValidos: any[]) {
    for (const pacote of pacotesValidos) {
      const itensValidos = pacote.pacoteVendaItens.filter((item: any) => {
        if (item.produto) {
          return;
        }

        if (item.ilimitado) {
          return item;
        }

        if (item.quantidadeUtilizada < item.quantidade) {
          return item;
        }
      });

      delete pacote.pacoteVendaItens;

      pacote.pacoteVendaItens = itensValidos;
    }

    return pacotesValidos;
  }

  async function confirmarNaoUtilizarPacote() {
    await confirmarAgendamento(pacotesSelecionado, servicos_selecionado);

    if (confirmationRef.current) {
      confirmationRef.current.fecharModal();
    }
  }

  async function retornaItensSelecionado(pacotes: any[]) {
    const itensSelecionado = [];

    for (const pacote of pacotes) {
      for (const item of pacote.pacoteVendaItens) {
        if (item.selecionado) {
          itensSelecionado.push(item);
        }
      }
    }

    return itensSelecionado;
  }

  async function confirmarUtilizacaoPacote() {
    const pacotesSelect = Object.assign([], pacotesSelecionado);
    const servicosEnviar = Object.assign([], servicos_selecionado);
    pacotesSelect.push(...pacoteSelecionadoValidacao);

    for (const item of pacotesSelect) {
      if (item.funcionario.id != route.params.profissional_selecionado.id) {
        setTextoModalInformacao(
          `Para utilizar esse pacote é necessário selecionar o profissional: ${item.funcionario.nome.toUpperCase()}, volte e selecione o profissional correto`,
        );
        refModalInformacao.current.abrirModal();

        return;
      }
    }

    const itensSelecionado = await retornaItensSelecionado(pacotesSelect);

    if (itensSelecionado.length > 0) {
      for (const item of itensSelecionado) {
        const index = servicosEnviar.findIndex((item_servico: any) => {
          return item_servico.id == item.servico.id;
        });

        if (index > -1) {
          servicosEnviar.splice(index, 1);
        }
      }
    }

    if (confirmationRef.current) {
      confirmationRef.current.fecharModal();
    }
    confirmarAgendamento(pacotesSelect, servicosEnviar);
  }

  async function agendar() {
    if (pacotes.length > 0) {
      const pctValidar = Object.assign([], pacotes);

      const pacotesValidos = await validaPacotesDentroPrazo(pctValidar);
      const pacotesComItensValidos = await validaItensPacotes(pacotesValidos);

      const pacoteEncontrado = [];

      for (const item_servico of servicos_selecionado) {
        let encontrado = false;

        // passo verificando se esse serviço existe dentro de algum pacote
        for (const pacotesValidos of pacotesComItensValidos) {
          for (const itensPacote of pacotesValidos.pacoteVendaItens) {
            if (itensPacote.servico.id == item_servico.id) {
              const identificaPacoteOriginal = pacotes.findIndex((item) => {
                return item.id == pacotesValidos.id;
              });

              // marca no item do pacote original como selecionado

              const pacoteSelec = pacotes[identificaPacoteOriginal];

              for (const encontraItem of pacoteSelec.pacoteVendaItens) {
                if (encontraItem.id == itensPacote.id) {
                  encontraItem.selecionado = true;
                  encontrado = true;
                  break;
                }
              }

              pacoteEncontrado.push(pacoteSelec);
              encontrado = true;
              break;
            }
          }

          if (encontrado) {
            break;
          }
        }
      }

      if (pacoteEncontrado.length > 0) {
        setPacoteSelecionadoValidacao(pacoteEncontrado);

        let nome_produtos = "";

        for (const pacote of pacoteEncontrado) {
          for (const item of pacote.pacoteVendaItens) {
            if (item.selecionado) {
              nome_produtos += item.servico.nome + ", ";
            }
          }
        }

        setMensagemConfirmaUtilizacaoPacote(
          "Você possui pacote para os serviços: " +
            nome_produtos +
            " deseja utilizar ?",
        );
        if (confirmationRef.current) {
          confirmationRef.current.abrirModal();
        }

        return;
      }
    }

    await confirmarAgendamento(pacotesSelecionado, servicos_selecionado);

    return;
  }

  async function confirmarAgendamento(
    pacotesUtilizado: any[],
    servicos_selecionado_: any[],
  ) {
    await refModal.current.abrirLoader();

    const agendar = await Api.agendar(
      data_selecionada,
      route.params.horarios_selecionado,
      route.params.cliente,
      servicos_selecionado_,
      route.params.profissional_selecionado,
      getCodEmpresa,
      pacotesUtilizado,
    );

    if (!agendar.status) {
      await refModal.current.fecharLoader();
      const message = agendar.error_details
        ? agendar.error_details.message
        : "Erro ao agendar";

      error("Atenção", message);
      return;
    }

    const cod_agendamento = agendar.data.agendendamento.id;

    const formata_data =
      data_selecionada.getDate() +
      "/" +
      (data_selecionada.getMonth() + 1) +
      "/" +
      data_selecionada.getFullYear() +
      " ás " +
      route.params.horarios_selecionado.horario;

    await refModal.current.fecharLoader();

    navigation.navigate("Comprovante", {
      data_hora_selecionada: formata_data,
      total: total.toFixed(2).replace(".", ","),
      id_agendamento: cod_agendamento,
      // usados pelo comprovante do layout novo
      data_selecionada: data_selecionada,
      horario: route.params.horarios_selecionado.horario,
      nome_profissional: route.params.profissional_selecionado?.nome,
      nomes_servicos: servicos_selecionado.map((item: any) => item.nome),
      nome_cliente: nome_cliente,
      valor_total: total,
    });
  }

  async function getPacotesCliente() {
    await refModal.current.abrirLoader();

    const servicos = await Api.pacotesCliente(
      getCodEmpresa,
      route.params.cliente.id,
    );

    if (!servicos.status) {
      refModal.current.abrirModal("Erro ao buscar Pacotes");
      await refModal.current.fecharLoader();
      return;
    }

    setPacotes(servicos.data);

    await refModal.current.fecharLoader();
  }

  function formataTelefone(text: String) {
    text = text.replace(/\D/g, "");

    let newCleaned = text.replace(/\D/g, "").substring(0, 11); // remove non-digit and limit
    if (newCleaned !== "") {
      let formatted = newCleaned;
      if (newCleaned.length >= 2) {
        formatted = `(${newCleaned.substring(0, 2)}) ${newCleaned.substring(2)}`;
      }
      if (newCleaned.length >= 7) {
        formatted = `(${newCleaned.substring(0, 2)}) ${newCleaned.substring(
          2,
          7,
        )}-${newCleaned.substring(7)}`;
      }

      return formatted;
    }
  }

  function linhaDadosPessoais(titulo: String, valor: String) {
    return (
      <Flex style={style.flexContainerDadosPessoais}>
        <Text
          style={[
            style.textLinhaPessoa,
            {
              marginRight: 10,
              color: getConfigEmpresa.coresPWA.corFontePrimaria,
            },
          ]}
          fontSize="md"
        >
          {titulo}
        </Text>

        <Text
          style={[
            style.textLinhaPessoa,
            {
              color: getConfigEmpresa.coresPWA.corFontePrimaria,
            },
          ]}
          fontSize="md"
        >
          {valor}
        </Text>
      </Flex>
    );
  }

  function informacoesPagamento() {
    return (
      <Box
        style={[
          style.servicosContainer,
          {
            borderBottomColor:
              getConfigEmpresa.coresPWA.corBordaLinhasConfirmacao || "#000",
          },
        ]}
      >
        <Flex style={style.footerFlexContainer}>
          <Text style={style.footerText} fontSize="lg">
            Tem Cupom ?
          </Text>
          <Text style={style.footerText} fontSize="lg">
            Digitar
          </Text>
        </Flex>

        <Flex style={style.footerFlexContainer}>
          <Text style={style.footerBoldText} fontSize="lg">
            Total
          </Text>
          <Text style={style.footerBoldText} fontSize="lg">
            {"R$ " + total.toFixed(2).replace(".", ",")}
          </Text>
        </Flex>

        <Flex style={style.footerFlexContainer}>
          <Text style={style.footerBoldText} fontSize="lg">
            Subtotal
          </Text>
          <Text style={style.footerBoldText} fontSize="lg">
            {"R$ " + total.toFixed(2).replace(".", ",")}
          </Text>
        </Flex>
      </Box>
    );
  }

  function linhaServicos() {
    return (
      <Box
        style={[
          style.servicosContainer,
          {
            borderBottomColor:
              getConfigEmpresa.coresPWA.corBordaLinhasConfirmacao || "#000",
          },
        ]}
      >
        <Text style={style.servicosLabel} fontSize="lg">
          <Flex direction="row" alignItems="center">
            <MaterialCommunityIcons
              name="scissors-cutting"
              size={20}
              color={getConfigEmpresa.coresPWA.corFontePrimaria}
              style={{ marginRight: 8 }}
            />
            Serviços:
          </Flex>
        </Text>
        {servicos_selecionado.map((item: any, index: number) => (
          <Box key={index} style={style.itemContainer}>
            <Flex style={style.flexContainer}>
              <Text style={style.itemNome} fontSize="lg">
                {item.nome}
              </Text>
              <Text
                style={{
                  ...style.itemValor,
                  width: "100%",
                  textAlign: "right",
                }}
                fontSize="lg"
              >
                {" R$ " + item.valor}
              </Text>
            </Flex>
          </Box>
        ))}
      </Box>
    );
  }

  function renderSelecionados(item: any, index: number) {
    // recupera todos os item.pacoteVendaItens que tem selecionado true

    const servicos = item.pacoteVendaItens.filter(
      (item: any) => item.selecionado == true,
    );

    return servicos.map((item: any, index: number) => (
      <Box key={index} style={style.itemContainer}>
        <Flex style={style.flexContainer}>
          <Text style={style.itemNome} fontSize="md">
            {(item.produto ? item.produto.descricao : item.servico.nome) +
              (item.produto ? " - Produto" : " - Serviço")}
          </Text>
        </Flex>
      </Box>
    ));
  }

  function linhaPacotes() {
    return (
      <Box
        style={[
          style.servicosContainer,
          {
            borderBottomColor:
              getConfigEmpresa.coresPWA.corBordaLinhasConfirmacao || "#000",
          },
        ]}
      >
        <Text style={style.servicosLabel} fontSize="lg">
          Pacote:
        </Text>
        {pacotesSelecionado.map((item: any, index: number) =>
          renderSelecionados(item, index),
        )}
      </Box>
    );
  }

  function linhaProfissional() {
    return (
      <Box
        style={[
          style.profissionalContainer,
          {
            borderBottomColor:
              getConfigEmpresa.coresPWA.corBordaLinhasConfirmacao || "#000",
          },
        ]}
      >
        <Text style={style.profissionalLabel} fontSize="md">
          <Flex direction="row" alignItems="center">
            <MaterialCommunityIcons
              name="account-tie"
              size={20}
              color={getConfigEmpresa.coresPWA.corFontePrimaria}
              style={{ marginRight: 8 }}
            />
            Profissional:
          </Flex>
        </Text>

        <Box style={style.innerBox}>
          <Flex style={style.flexImageContainer}>
            {isMobile && (
              <Image
                source={
                  route.params &&
                  route.params.profissional_selecionado.foto == null
                    ? require("../../../img/avatar-pessoa.jpg")
                    : {
                        uri:
                          route.params &&
                          route.params.profissional_selecionado.foto?.url,
                      }
                }
                alt="Avatar"
                resizeMode="contain"
                style={style.professionalImage}
              />
            )}
            <Text
              style={[style.professionalName, !isMobile && { marginLeft: 0 }]}
            >
              {route.params && route.params.profissional_selecionado.nome}
            </Text>
          </Flex>
        </Box>
      </Box>
    );
  }

  function linhaHorarios() {
    return (
      <Flex
        style={[
          style.flexHorarioContainer,
          {
            borderBottomColor:
              getConfigEmpresa.coresPWA.corBordaLinhasConfirmacao || "#000",
          },
        ]}
      >
        <Text style={style.labelHorarioText} fontSize="md">
          Horário:
        </Text>

        <Text style={style.dataHorarioText} fontSize="md">
          {route.params && route.params.horarios_selecionado.horario}
        </Text>
      </Flex>
    );
  }

  function linhaData() {
    const data_formatada =
      dias_semana[data_selecionada.getDay()] +
      " " +
      data_selecionada.getDate() +
      " " +
      meses[data_selecionada.getMonth()] +
      " de " +
      data_selecionada.getFullYear();

    return (
      <Flex style={style.flexContainer}>
        <Text style={style.labelText} fontSize="md">
          Data:
        </Text>

        <Text style={style.dataText} fontSize="md">
          {data_formatada}
        </Text>
      </Flex>
    );
  }

  function voltar() {
    if (route.params && route.params.validarLogin) {
      route.params.validarLogin();
    }

    navigation.goBack();
  }

  function renderModais() {
    return (
      <>
        <ModalConfirmacao
          ref={confirmationRef}
          titulo={"Atenção"}
          mensagem={mensagemConfirmaUtilizacaoPacote}
          textoBotaoNegativo={"Não Utilizar"}
          textoBotaoPositivo={"Utilizar"}
          onConfirmNegativo={() => confirmarNaoUtilizarPacote()}
          onConfirmPositivo={() => confirmarUtilizacaoPacote()}
        />

        <ModalConfirmacao
          titulo={"Atenção"}
          ref={refModalInformacao}
          mensagem={textoModalInformacao}
          textoBotaoPositivo={"OK"}
          onConfirmPositivo={() => {
            if (refModalInformacao.current) {
              refModalInformacao.current.fecharModal();
            }
            if (confirmationRef.current) {
              confirmationRef.current.fecharModal();
            }
          }}
        />
      </>
    );
  }

  // ---------------- Layout novo ----------------
  // O modo legado (pwa simples / layout v2 / tema escuro) continua com o template antigo
  const utilizaLayoutLegado =
    getConfigEmpresa.utilizaPwaSimples ||
    getConfigEmpresa.versaoPWA == 2 ||
    getConfigEmpresa.utilizaTemaEscuro;

  const corPrincipal: string = primaryColor || "#006400";
  const corTextoPrincipal = corTextoSobre(corPrincipal);

  function formatarValor(valor: any) {
    return Number(valor || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  function iniciais(nome: String) {
    const partes = String(nome || "")
      .trim()
      .split(" ")
      .filter((p) => p);
    if (partes.length === 0) return "?";
    const primeira = partes[0].charAt(0);
    const ultima = partes.length > 1 ? partes[partes.length - 1].charAt(0) : "";
    return (primeira + ultima).toUpperCase();
  }

  function renderCardAgendamento() {
    const profissional = route.params?.profissional_selecionado;

    return (
      <div
        style={{
          borderRadius: 20,
          overflow: "hidden",
          marginBottom: 14,
          backgroundColor: corPrincipal,
          backgroundImage: gradienteCard(corPrincipal),
          boxShadow: "0 10px 24px rgba(0,0,0,0.16)",
        }}
      >
        <View style={stylesNovo.topoAgendamento}>
          <View style={stylesNovo.caixaData}>
            <RNText style={[stylesNovo.mesCaixaData, { color: corPrincipal }]}>
              {meses[data_selecionada.getMonth()].substring(0, 3).toUpperCase()}
            </RNText>
            <RNText style={stylesNovo.diaCaixaData}>
              {data_selecionada.getDate()}
            </RNText>
          </View>

          <View style={{ flex: 1 }}>
            <RNText style={[stylesNovo.semanaAgendamento, { color: corTextoPrincipal }]}>
              {dias_semana[data_selecionada.getDay()]}
            </RNText>
            <RNText style={[stylesNovo.horaAgendamento, { color: corTextoPrincipal }]}>
              às {route.params?.horarios_selecionado?.horario}
            </RNText>
          </View>
        </View>

        {!!profissional && (
          <View style={stylesNovo.rodapeAgendamento}>
            {profissional.foto?.url ? (
              <RNImage
                source={{ uri: profissional.foto.url }}
                style={stylesNovo.fotoProfissional}
              />
            ) : (
              <View
                style={[
                  stylesNovo.fotoProfissional,
                  { backgroundColor: "rgba(255,255,255,0.2)" },
                ]}
              >
                <RNText style={{ color: "#fff", fontWeight: "800" }}>
                  {iniciais(profissional.nome).charAt(0)}
                </RNText>
              </View>
            )}
            <View>
              <RNText style={[stylesNovo.rotuloCom, { color: corTextoPrincipal }]}>
                Com
              </RNText>
              <RNText style={[stylesNovo.nomeProfissional, { color: corTextoPrincipal }]}>
                {profissional.nome}
              </RNText>
            </View>
          </View>
        )}
      </div>
    );
  }

  function renderCardServicos() {
    const itensPacote: any[] = [];
    for (const pacote of pacotesSelecionado) {
      for (const item of pacote.pacoteVendaItens || []) {
        if (item.selecionado) {
          itensPacote.push(item);
        }
      }
    }

    if (servicos_selecionado.length === 0 && itensPacote.length === 0) {
      return null;
    }

    return (
      <View style={[stylesNovo.card, sombraCard]}>
        <View style={stylesNovo.cabecalhoCard}>
          <RNText style={stylesNovo.tituloCard}>SERVIÇOS</RNText>
        </View>

        {servicos_selecionado.map((item: any, index: number) => (
          <View key={"s" + index} style={stylesNovo.linhaServico}>
            <RNText style={stylesNovo.nomeServico}>{item.nome}</RNText>
            <RNText style={stylesNovo.valorServico}>
              {formatarValor(item.valor)}
            </RNText>
          </View>
        ))}

        {itensPacote.map((item: any, index: number) => (
          <View key={"p" + index} style={stylesNovo.linhaServico}>
            <RNText style={stylesNovo.nomeServico}>
              {item.produto ? item.produto.descricao : item.servico.nome}
            </RNText>
            <RNText style={[stylesNovo.valorServico, { color: corPrincipal }]}>
              Pacote
            </RNText>
          </View>
        ))}

        <View style={stylesNovo.linhaTotal}>
          <RNText style={stylesNovo.rotuloTotal}>Total</RNText>
          <RNText style={[stylesNovo.valorTotal, { color: corPrincipal }]}>
            {formatarValor(total)}
          </RNText>
        </View>
      </View>
    );
  }

  function renderCardDados() {
    return (
      <View style={[stylesNovo.card, sombraCard]}>
        <View style={stylesNovo.cabecalhoCard}>
          <RNText style={stylesNovo.tituloCard}>SEUS DADOS</RNText>
        </View>

        <View style={stylesNovo.linhaDados}>
          <View
            style={[
              stylesNovo.avatarIniciais,
              { backgroundColor: corComAlpha(corPrincipal, 0.1) },
            ]}
          >
            <RNText style={[stylesNovo.textoIniciais, { color: corPrincipal }]}>
              {iniciais(nome_cliente)}
            </RNText>
          </View>
          <View style={{ flex: 1 }}>
            <RNText style={stylesNovo.nomeCliente}>{nome_cliente}</RNText>
            {!clienteFinal && !!telefone_cliente && (
              <RNText style={stylesNovo.telefoneCliente}>
                {formataTelefone(telefone_cliente)}
              </RNText>
            )}
          </View>
        </View>
      </View>
    );
  }

  if (!utilizaLayoutLegado) {
    return (
      <TemplateEtapas
        ref={refModal}
        rotuloEtapa="Revisão"
        titulo="Tudo certo?"
        onVoltarClick={voltar}
        textoBotao="Confirmar agendamento"
        iconeBotao="check"
        onBotaoClick={agendar}
      >
        {renderCardAgendamento()}
        {renderCardServicos()}
        {renderCardDados()}
        {renderModais()}
      </TemplateEtapas>
    );
  }

  // ---------------- Layout legado ----------------
  return (
    <Template
      titulo={"Confirme seu Agendamento"}
      // disabled_button_proximo={mensagemRodape != ''}
      messageAlerta="Por favor, verifique com cuidado e confirme os dados do agendamento"
      titulo_botao_proximo={"Agendar"}
      onBotaoProximoClick={() => {
        agendar();
      }}
      onBotaoVoltarClick={voltar}
      ref={refModal}
    >
      <Box style={style.mainContainer}>
        <Card
          style={{
            margin: 2,
            width: "100%",
            backgroundColor: getConfigEmpresa.coresPWA.corFundo,
            borderColor:
              getConfigEmpresa.coresPWA.corBordaLinhasConfirmacao || "#000",
            border: "solid",
          }}
        >
          <Flex
            direction="row"
            alignItems="center"
            style={{
              borderBottomWidth: 1,
              borderBottomColor:
                getConfigEmpresa.coresPWA.corBordaLinhasConfirmacao ||
                "rgba(0, 0, 0, 0.1)",
              paddingBottom: 8,
              marginBottom: 15,
            }}
          >
            <MaterialCommunityIcons
              name="account-details"
              size={24}
              color={getConfigEmpresa.coresPWA.corFontePrimaria}
              style={{ marginRight: 10 }}
            />
            <Text
              style={{
                fontWeight: "600",
                color: getConfigEmpresa.coresPWA.corFontePrimaria,
                fontSize: RFPercentage(2.8),
              }}
            >
              Informações pessoais
            </Text>
          </Flex>

          {linhaDadosPessoais("Nome: ", nome_cliente)}
          {!clienteFinal &&
            linhaDadosPessoais("Telefone: ", formataTelefone(telefone_cliente))}
        </Card>
        <Card
          style={{
            margin: 2,
            marginTop: 10,
            width: "100%",
            backgroundColor: getConfigEmpresa.coresPWA.corFundo,
            borderColor:
              getConfigEmpresa.coresPWA.corBordaLinhasConfirmacao || "#000",
            border: "solid",
          }}
        >
          <Flex
            direction="row"
            alignItems="center"
            style={{
              borderBottomWidth: 1,
              borderBottomColor:
                getConfigEmpresa.coresPWA.corBordaLinhasConfirmacao ||
                "rgba(0, 0, 0, 0.1)",
              paddingBottom: 8,
              marginBottom: 15,
            }}
          >
            <MaterialCommunityIcons
              name="calendar-clock"
              size={24}
              color={getConfigEmpresa.coresPWA.corFontePrimaria}
              style={{ marginRight: 10 }}
            />
            <Text
              style={{
                fontWeight: "600",
                color: getConfigEmpresa.coresPWA.corFontePrimaria,
                fontSize: RFPercentage(2.8),
              }}
            >
              Informações do agendamento
            </Text>
          </Flex>
          {linhaData()}
          {linhaHorarios()}
          {linhaProfissional()}
          {servicos_selecionado.length > 0 && linhaServicos()}
        </Card>
        <Card
          style={{
            margin: 2,
            marginTop: 10,
            width: "100%",
            backgroundColor: getConfigEmpresa.coresPWA.corFundo,
            borderColor:
              getConfigEmpresa.coresPWA.corBordaLinhasConfirmacao || "#000",
            border: "solid",
          }}
        >
          <Flex
            direction="row"
            alignItems="center"
            style={{
              borderBottomWidth: 1,
              borderBottomColor:
                getConfigEmpresa.coresPWA.corBordaLinhasConfirmacao ||
                "rgba(0, 0, 0, 0.1)",
              paddingBottom: 8,
              marginBottom: 15,
            }}
          >
            <MaterialCommunityIcons
              name="credit-card-outline"
              size={24}
              color={getConfigEmpresa.coresPWA.corFontePrimaria}
              style={{ marginRight: 10 }}
            />
            <Text
              style={{
                fontWeight: "600",
                color: getConfigEmpresa.coresPWA.corFontePrimaria,
                fontSize: RFPercentage(2.8),
              }}
            >
              Informações do pagamento
            </Text>
          </Flex>
          {pacotesSelecionado.length > 0 && linhaPacotes()}
          {informacoesPagamento()}
        </Card>
      </Box>

      {renderModais()}
    </Template>
  );
}


const stylesNovo = StyleSheet.create({
  topoAgendamento: {
    flexDirection: "row",
    alignItems: "center",
    gap: 14,
    padding: 16,
  },
  caixaData: {
    width: 56,
    height: 60,
    borderRadius: 14,
    backgroundColor: "#fff",
    alignItems: "center",
    justifyContent: "center",
  },
  mesCaixaData: {
    fontSize: 11,
    fontWeight: "800",
    letterSpacing: 1,
  },
  diaCaixaData: {
    fontSize: 22,
    fontWeight: "800",
    color: CORES.titulo,
    lineHeight: 24,
  },
  semanaAgendamento: {
    fontSize: 13,
    opacity: 0.85,
  },
  horaAgendamento: {
    fontSize: 24,
    fontWeight: "800",
  },
  rodapeAgendamento: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    paddingVertical: 12,
    paddingHorizontal: 16,
    backgroundColor: "rgba(0,0,0,0.18)",
    borderTopWidth: 1,
    borderTopColor: "rgba(255,255,255,0.1)",
  },
  fotoProfissional: {
    width: 34,
    height: 34,
    borderRadius: 17,
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  rotuloCom: {
    fontSize: 11,
    opacity: 0.75,
  },
  nomeProfissional: {
    fontSize: 15,
    fontWeight: "700",
  },
  card: {
    backgroundColor: CORES.card,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: CORES.borda,
    padding: 16,
    marginBottom: 14,
  },
  cabecalhoCard: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 12,
  },
  tituloCard: {
    fontSize: 11,
    fontWeight: "800",
    letterSpacing: 1.5,
    color: CORES.subtitulo,
  },
  linhaServico: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    paddingVertical: 8,
  },
  nomeServico: {
    flex: 1,
    fontSize: 15,
    color: CORES.titulo,
  },
  valorServico: {
    fontSize: 15,
    fontWeight: "600",
    color: CORES.titulo,
  },
  linhaTotal: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 10,
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: CORES.borda,
  },
  rotuloTotal: {
    fontSize: 15,
    fontWeight: "700",
    color: CORES.titulo,
  },
  valorTotal: {
    fontSize: 24,
    fontWeight: "800",
  },
  linhaDados: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  avatarIniciais: {
    width: 44,
    height: 44,
    borderRadius: 22,
    alignItems: "center",
    justifyContent: "center",
  },
  textoIniciais: {
    fontSize: 15,
    fontWeight: "800",
  },
  nomeCliente: {
    fontSize: 15,
    fontWeight: "700",
    color: CORES.titulo,
  },
  telefoneCliente: {
    fontSize: 13,
    color: CORES.subtitulo,
    marginTop: 2,
  },
});
